import { arrayIncludes } from './array';
export const isObject = (o) => typeof o === 'object' && o !== null;
export const sortObjectByKeys = (unordered) => Object.keys(unordered)
    .sort()
    .reduce((obj, key) => (Object.assign(Object.assign({}, obj), { [key]: unordered[key] })), {});
export const objectIncludes = (o, p) => Object.keys(p).every((key) => {
    if (p[key] === undefined) {
        return Object.hasOwn(o, key) && o[key] === undefined;
    }
    if (isObject(p[key])) {
        return isObject(o[key]) ? objectIncludes(o[key], p[key]) : false;
    }
    if (Array.isArray(p[key])) {
        return Array.isArray(o[key]) ? arrayIncludes(o[key], p[key]) : false;
    }
    return o[key] === p[key];
});
export const getSize = (o) => Object.keys(o).length;
export const removeUndefinedValues = (o) => JSON.parse(JSON.stringify(o));
export const removeNullishValues = (o) => Object.keys(o).reduce((acc, key) => {
    if (o[key] !== null && o[key] !== undefined) {
        return Object.assign(Object.assign({}, acc), { [key]: o[key] });
    }
    return acc;
}, {});
